import { useLayoutEffect } from 'react';

// Size a composer textarea to its content.
//
// Height must be a function of the current text, not of the last keystroke:
// setting `value` from React state does not fire a DOM `input` event, so a
// draft loaded from Firestore (or put back after a failed send) would otherwise
// be displayed in a collapsed one-row box with the rest hidden.
export function useAutoGrowTextarea(ref, value, maxHeightPx = 120) {
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    el.style.height = Math.min(el.scrollHeight, maxHeightPx) + 'px';
  }, [ref, value, maxHeightPx]);
}
